import { render, staticRenderFns } from "./m-practices.vue?vue&type=template&id=51dde7ca&scoped=true"
import script from "./m-practices.vue?vue&type=script&lang=js"
export * from "./m-practices.vue?vue&type=script&lang=js"
import style0 from "./m-practices.vue?vue&type=style&index=0&id=51dde7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dde7ca",
  null
  
)

export default component.exports